import { RailgunBase } from 'src/app/RailgunBase';

/**
 * BaseController
 *
 * BaseViewに対応する形のベースコントローラー
 */
export class BaseController extends RailgunBase {

	// 対応するViewのインスタンス
	// BaseViewで設定される
	public combineView: any;

}
